import script from "./PackageEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageEdit.vue?vue&type=script&setup=true&lang=js"

import "./PackageEdit.vue?vue&type=style&index=0&id=58b97c1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b97c1e"]])

export default __exports__